import React, { useMemo } from 'react';
import { pick, pipe, prop } from 'ramda';
import { MultiSelect } from 'js/components/common/Fields/MultiSelect';
import { useGameConfigurationSelector } from 'js/store/hooks';
import { usePortletDispatch, usePortletSelector, usePortletTranslations } from 'js/components/system/Portlet';

import { CATEGORY_TYPE } from 'js/components/main/Games/constants';
import { setFilterCategoriesAction } from '@core/js/components/main/Games/Filters/actions';
import { filterByEmptyGames } from '@core/js/components/main/Games/Filters/filters';

import style from './index.scss';

export const Categories = () => {
    const games = useGameConfigurationSelector(prop('games'));
    const {
        categories,
        filters: { selectedCategories }
    } = usePortletSelector(pick(['categories', 'filters']));
    const t = usePortletTranslations();
    const dispatch = usePortletDispatch();

    const filteredCategories = useMemo(
        () => pipe(
            filterByEmptyGames
        )(categories),
        [categories]
    );

    const options = categories
        .filter(({ cid }) => !(cid === CATEGORY_TYPE.FAVORITES || cid === CATEGORY_TYPE.RECENTLY))
        .map(({ cid: id, displayName }) => {
            const { gameCodes = [], mostPlayedGameCode } = filteredCategories.find(cat => cat.cid === id) || {};
            const gameName = games[mostPlayedGameCode]?.name || '';

            return {
                id,
                label: t(displayName, [gameName]),
                hint: `(${gameCodes.length})`
            };
        });

    const onChange = (selected) => {
        dispatch(setFilterCategoriesAction(selected));
    };

    return (
        <MultiSelect
            label={t('gamesCategories')}
            options={options}
            selected={selectedCategories}
            onChange={onChange}
            className={style.categoriesFilter}
            classNames={{ control: style.multiSelectCheckboxControl }}
        />
    );
};

export default Categories;
